/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  CREATE_NOTICEBOARD(state, payload) {
    state.noticeBoards.unshift(payload)
  },
  UPDATE_NOTICEBOARD(state, payload) {
    var index = state.noticeBoards.findIndex(function(item){return item.id == payload.id})
    state.noticeBoards[index] = payload
  },
  UPDATE_ANSWER(state, payload){
    var index = state.noticeBoards.findIndex(function(item){return item.id == payload.id})
    state.noticeBoards[index].answer = payload.answer
    state.noticeBoards[index].answer_user = payload.answer_user

  },
  DELETE_NOTICEBOARD_ANSWER(state, payload) {
    var index = state.noticeBoards.findIndex(function(item){return item.id == payload.id})
    state.noticeBoards[index].answer = ""
    state.noticeBoards[index].answer_user = ""
  },
  DELETE_NOTICEBOARD_QUESTION(state, payload) {
    var index = state.noticeBoards.findIndex(function(item){return item.id == payload.id})
    state.noticeBoards.splice(index,1)
  },
  SET_ACTIVE_NOTICEBOARD(state, payload) {
    state.ActiveNoticeBoard = payload
  },
  SET_NOTICEBOARD_LIST(state, payload){
    state.noticeBoards = payload.sort(function(a,b) {return a.update_time > b.update_time ? -1 : a.update_time > b.update_time ? 1 : 0 })
  },
  SET_NOTICEBOARD_SEARCH_QUERY(state, query) {
    state.noticeBoardSearchQuery.keywoard = query.keywoard
    state.noticeBoardSearchQuery.id = query.id
    state.noticeBoardSearchQuery.state = query.state
  },
}
